import image1 from './small/1.png';
import image2 from './small/2.png';
import image3 from './small/3.png';
import image4 from './small/4.png';
import image5 from './small/5.png';
import image6 from './small/6.png';
import image7 from './small/7.png';
import image8 from './small/8.png';
import image9 from './small/9.png';
import image10 from './small/10.png';
import image11 from './small/11.png';
import image12 from './small/12.png';
import image13 from './small/13.png';
import image14 from './small/14.png';
import image15 from './small/15.png';
import image16 from './small/16.png';
import image17 from './small/17.png';
import image18 from './small/18.png';
import image19 from './small/19.png';
import image20 from './small/20.png';
import image21 from './small/21.png';
import image22 from './small/22.png';
import image23 from './small/23.png';
import image24 from './small/24.png';
import image25 from './small/25.png';
import image26 from './small/26.png';
import image27 from './small/27.png';
import image28 from './small/28.png';
import image29 from './small/29.png';
import image30 from './small/30.png';
import image31 from './small/31.png';
import image32 from './small/32.png';
import image33 from './small/33.png';
import image34 from './small/34.png';
import image35 from './small/35.png';
import image36 from './small/36.png';
const jsonData = [
  {
    id: 1,
    imageUrl: image1
  },
  {
    id: 2,
    imageUrl: image2
  },
  {
    id: 3,
    imageUrl: image3
  },
  {
    id: 4,
    imageUrl: image4
  },
  {
    id: 5,
    imageUrl: image5
  },
  {
    id: 6,
    imageUrl: image6
  },
  {
    id: 7,
    imageUrl: image7
  },
  {
    id: 8,
    imageUrl: image8
  },
  {
    id: 9,
    imageUrl: image9
  },
  {
    id: 10,
    imageUrl: image10
  },
  {
    id: 11,
    imageUrl: image11
  },
  {
    id: 12,
    imageUrl: image12
  },
  {
    id: 13,
    imageUrl: image13
  },
  {
    id: 14,
    imageUrl: image14
  },
  {
    id: 15,
    imageUrl: image15
  },
  {
    id: 16,
    imageUrl: image16
  },
  {
    id: 17,
    imageUrl: image17
  },
  {
    id: 18,
    imageUrl: image18
  },
  {
    id: 19,
    imageUrl: image19
  },
  {
    id: 20,
    imageUrl: image20
  },
  {
    id: 21,
    imageUrl: image21
  },
  {
    id: 22,
    imageUrl: image22
  },
  {
    id: 23,
    imageUrl: image23
  },
  {
    id: 24,
    imageUrl: image24
  },
  {
    id: 25,
    imageUrl: image25
  },
  {
    id: 26,
    imageUrl: image26
  },
  {
    id: 27,
    imageUrl: image27
  },
  {
    id: 28,
    imageUrl: image28
  },
  {
    id: 29,
    imageUrl: image29
  },
  {
    id: 30,
    imageUrl: image30
  },
  {
    id: 31,
    imageUrl: image31
  },
  {
    id: 32,
    imageUrl: image32
  },
  {
    id: 33,
    imageUrl: image33
  },
  {
    id: 34,
    imageUrl: image34
  },
  {
    id: 35,
    imageUrl: image35
  },
  {
    id: 36,
    imageUrl: image36
  }
  
];
export default jsonData